// Clamp a number between min and max (inclusive).
// Examples:
// - clamp(15, 0, 10) === 10  // clamps down
// - clamp(-3, 0, 10) === 0   // clamps up
export const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}
